import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "isFluid"];
import React from 'react';
import pt from 'prop-types';
import { Element } from '../';
import { extendProps, appendHtmlClass } from '../../js/util';
import './_index.scss';
var Container = function Container(props) {
  var className = props.className,
    children = props.children,
    isFluid = props.isFluid,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  className = appendHtmlClass(className, 'container');
  if (isFluid) className = appendHtmlClass(className, 'fluid');
  return /*#__PURE__*/React.createElement(Element, Object.assign({
    className: className
  }, other), children);
};
Object.assign(Container, extendProps(Element, ['align', 'className', 'id', 'style', 'as', 'isAnimated'], {
  isFluid: pt.bool
}, {
  isFluid: false
}));
export default Container;